import { Pipe, PipeTransform } from '@angular/core';
import { Team } from '@team/model';

@Pipe({
  name: 'teamCellFormat',
})
export class TeamCellFormatPipe implements PipeTransform {
  transform(value: Team): { name: string; parentCount: number } {
    if (!value.isStructural) {
      return { name: value.name, parentCount: 0 };
    }

    let parent = value.parent;
    let count = 0;
    while (parent) {
      count++;
      parent = parent.parent;
    }
    return { name: value.name, parentCount: count };
  }
}
